// This is just an example,
// so you can safely delete all default props below

export default {
    email: 'E-post (som skrevet på din billett)',
    booking_number: 'Billettnr.',
    find: 'Finn billett',
    order_time: 'Bestillings tidspunkt',
    total: 'Total',
    status: 'Status',
    select: 'Velg avgang',
    cancelled: 'Avbestilt',
    cancel_selected: 'Avbestill valgt avgang',
    error_booking_number: 'Billettnr. er nødvendig',
    error_email: 'E-post er nødvendig',
    error_order_not_found: 'Vi fant ingen billett på oppgitt informasjon, sjekk billettnummer og/eller epostadressen om det er riktig skrevet, og prøv på nytt.',
    error_trip_selection: 'Avgang som skal avbestilles må velges',
    failed: 'Avbestilling feilet',
    success: 'Avbestilling vellykket',
    error_cancellation_time_passed: 'Avreisetidspunktet er passert, avbestillingen kan ikke gjennomføres.'
}
